import { ChakraV3 } from '@piccolohealth/ui';
import { P } from '@piccolohealth/util';
import React from 'react';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import type { HocuspocusState, SaveInfo } from './hooks/useHocuspocusProvider';

const saveProps = (save: SaveInfo) => {
  return {
    'data-save-count': save.saveCount,
    'data-last-saved-at': save.lastSavedAt,
  };
};

interface Props {
  state: HocuspocusState;
}

export const SaveStatusIndicator = (props: Props) => {
  const { state } = props;

  const content = P.run(() => {
    switch (state.status) {
      case 'disconnected':
      case 'outdated': {
        return <ChakraV3.Text>Disconnected</ChakraV3.Text>;
      }
      case 'connecting': {
        return (
          <>
            <ChakraV3.Spinner size='sm' />
            <ChakraV3.Text>Connecting...</ChakraV3.Text>
          </>
        );
      }
      case 'error':
        return (
          <>
            <FaTimesCircle />
            <ChakraV3.Text color='red.400'>Error</ChakraV3.Text>
          </>
        );
      case 'reconnecting': {
        return (
          <>
            <ChakraV3.Spinner size='sm' />
            <ChakraV3.Text {...saveProps(state.save)}>Reconnecting...</ChakraV3.Text>
          </>
        );
      }
      case 'connected':
        return P.run(() => {
          switch (state.save.saveStatus) {
            case 'unsaved': {
              return <ChakraV3.Text {...saveProps(state.save)}>Unsaved</ChakraV3.Text>;
            }
            case 'saving': {
              return (
                <>
                  <ChakraV3.Spinner size='sm' />
                  <ChakraV3.Text {...saveProps(state.save)}>Saving...</ChakraV3.Text>
                </>
              );
            }
            case 'saved': {
              return (
                <>
                  <FaCheckCircle />
                  <ChakraV3.Text {...saveProps(state.save)}>Saved</ChakraV3.Text>
                </>
              );
            }
          }
        });
    }
  });

  return (
    <ChakraV3.HStack
      alignItems='center'
      fontSize='sm'
      fontWeight='semibold'
      color='gray.600'
      lineHeight={1}
    >
      {content}
    </ChakraV3.HStack>
  );
};
